module.exports = __webpack_public_path__ + "images/help/icon-twr61-9b1dd3450b53f49d835cb8addf36a81a.png";